import script from "./xiaolibanjikebiao.vue?vue&type=script&setup=true&lang=js"
export * from "./xiaolibanjikebiao.vue?vue&type=script&setup=true&lang=js"

import "./xiaolibanjikebiao.vue?vue&type=style&index=0&id=3ffefc9a&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ffefc9a"]])

export default __exports__